import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer>
      <div className="container footer-container">
        <div className="copyright">
          &copy; {currentYear} Maryam
        </div>
        <div className="social-links">
          <a 
            href="https://www.facebook.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="Facebook"
            className="facebook-link"
          >
            <FontAwesomeIcon icon={faFacebookSquare} /> Facebook
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 